import React from 'react'
import girl from '../../../assets/images/profiles/girl.jpeg';
import man from '../../../assets/images/profiles/man.jpeg';
import ListItem from '../../../components/list';
import Avatar from '../../../components/avatar';
import { IconCompany } from '../../../components';

function Testimonials() {
    const data = [
    {
        name: "Am",
        message: "BCL took away the stress of researching suppliers. I now spend more time growing my import and export business.",
        stars: 5,
        authorType: "man"
    },
    {
        name: "Jul",
        message: "Buying land used to feel overwhelming. BCL simplified everything and gave me confidence every step of the way.",
        stars: 4.5,
        authorType: "woman"
    },
    {
        name: "Welln",
        message: "The professionalism and speed exceeded our expectations. BCL helped us make informed business decisions with ease.",
        stars: 4.5,
        authorType: "company"
    },
    {
        name: "Kofi",
        message: "From consultation to delivery, the entire experience was smooth. I wish I had discovered BCL much earlier.",
        stars: 5,
        authorType: "man"
    },
    {
        name: "Akos",
        message: "BCL removed all the confusion. What seemed like a complicated process became simple and straightforward.",
        stars: 5,
        authorType: "woman"
    },
    {
        name: "Build",
        message: "Working with BCL saved our company weeks of effort. Their expertise helped us move faster with complete peace of mind.",
        stars: 5,
        authorType: "company"
    },
];
    return (
        <div className='testimonials'>
            <h3 id='testimonials'>Testimonials</h3>
            <div className='testi-list'>
                {
                    data.map((a, i) => {
                        return (
                            <ListItem key={i} className='testim bx' left={a.authorType === "company" ? <IconCompany size={45} /> : <Avatar url={a.authorType === "woman" ? girl : man} />}
                                title={
                                    <>
                                        Client {a.name}... - <span>{a.stars} stars</span>
                                    </>
                                }
                                subtitle={a.message} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Testimonials
